var map = {
	"./en/formatXML/i18nFormatXML70": [
		"75fe",
		"i18n-formatXML70-en-formatXML-i18nFormatXML70"
	],
	"./vi/formatXML/i18nFormatXML70": [
		"6b71",
		"i18n-formatXML70-vi-formatXML-i18nFormatXML70"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "4631";
module.exports = webpackAsyncContext;